import { DevicePlatform } from '@gem/components';

import { PlatformTypesEnum } from 'APP/model/userSettings/userSettingsModel.types';

export const matchPlatformNameToDevicePlatform = (platform: PlatformTypesEnum): DevicePlatform => {
  switch (platform) {
    case PlatformTypesEnum.WEB:
      return DevicePlatform.Web;
    case PlatformTypesEnum.IOS:
      return DevicePlatform.Ios;
    case PlatformTypesEnum.ANDROID:
      return DevicePlatform.Android;
    case PlatformTypesEnum.HUAWEI:
      return DevicePlatform.Huawei;
    case PlatformTypesEnum.DESKTOP:
      return DevicePlatform.Desktop;
    case PlatformTypesEnum.OTHER:
      return DevicePlatform.Other;
  }
};
